module.exports = window["ff-query"];